<script setup lang="ts">
import type { IProps } from './VimeoPlayer.types'

defineProps<IProps>()
</script>

<template>
  <div class="vimeoPlayer">
    <div class="vimeoPlayer__wrapper">
      <iframe
        id="vimeoPlayer"
        class="vimeoPlayer__iframe"
        :src="src"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
        :title="title"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.vimeoPlayer {
  max-width: 156rem;
  margin: auto;
  padding: 0 2.6rem;

  &__wrapper {
    position: relative;
    padding: 56.25% 0 0 0;
  }
  
  &__iframe {
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
  }
}

</style>
